import { QueryClient } from "@tanstack/react-query";
import { OVERVIEW_TASKS_QUERY_KEY } from "../../TasksOverview/constants/queryKeys";
import { FileUploadType } from "@fixa/file-upload";

const TASK_TYPES_QUERY_KEY = "task-types";
const TASKS_V2_QUERY_KEY = "tasks_v2";
const UPLOADS_QUERY_KEY = "uploads";

export function getAllTaskTypesQueryKey() {
  return [TASK_TYPES_QUERY_KEY];
}

export function getTaskTypesQueryKey(ids: string[]) {
  return [TASK_TYPES_QUERY_KEY, ids.toSorted()];
}

export function invalidateTaskTypesQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({ queryKey: [TASK_TYPES_QUERY_KEY] });
}

function getTasksQueryKey(ids: string[] | null) {
  return [TASKS_V2_QUERY_KEY, ids === null ? null : ids.toSorted()];
}

export function getTaskQueryKey(id: string | null) {
  return getTasksQueryKey(id === null ? null : [id]);
}

export function getTaskLogsQueryKey(id: string | null) {
  return [TASKS_V2_QUERY_KEY, id, "logs"];
}

export function getTaskScheduleQueryKey(taskId: string | null) {
  return [TASKS_V2_QUERY_KEY, taskId, "schedule"];
}

export function getTaskCommentsQueryKey(id: string | null) {
  return [TASKS_V2_QUERY_KEY, id, "comments"];
}

export function getTaskImagesQueryKey(id: string | null) {
  return [TASKS_V2_QUERY_KEY, id, "images"];
}

export function getTaskFilesQueryKey(id: string | null) {
  return [TASKS_V2_QUERY_KEY, id, "files"];
}

export function getTaskCommentsImagesQueryKey(id: string | null) {
  return [TASKS_V2_QUERY_KEY, id, "comments", "images"];
}

export function getTasksByTypeQueryKey(
  taskTypeId: string | null | undefined,
  storeId: string | null | undefined,
  state: string | null | undefined
) {
  return [TASKS_V2_QUERY_KEY, "by-type", taskTypeId, storeId, state];
}

export function invalidateTaskQueries(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: [TASKS_V2_QUERY_KEY] }),
    queryClient.invalidateQueries({ queryKey: [OVERVIEW_TASKS_QUERY_KEY] }),
  ]);
}

export function getWriteSignedUrlsQueryKey(
  fileNames: string[],
  uploadType: FileUploadType
) {
  return [
    UPLOADS_QUERY_KEY,
    "write-signed-urls",
    { fileNames: fileNames.toSorted(), uploadType },
  ];
}
